import {getEntityActions} from '@igp/shared/redux/entity';
import {getMessageActions} from '@igp/shared/redux/message';
import {getRealtimeActions} from '@igp/shared/redux/realtime';
import {getViewActions} from '@igp/shared/redux/view';
import type {EntityType} from '@models';

export const viewActions = getViewActions<EntityType>();
export const realtimeActions = getRealtimeActions<EntityType>();
export const entityActions = getEntityActions<EntityType>();
export const messageActions = getMessageActions();
